import React from 'react';
import { CommonWrapper, OverflowHiddenWrapper } from 'screens/AgentOfficePages/styled';
import * as Styled from './styled';

export const OverflowShadow: React.FC<{ color?: string }> = ({ children, color }) => {
  return (
    <OverflowHiddenWrapper>
      <CommonWrapper>
        <Styled.ShadowWrapper color={color}>
          {children}
        </Styled.ShadowWrapper>
      </CommonWrapper>
    </OverflowHiddenWrapper>
  );
};
